//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
name: 'CZhead';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(['user', 'identities']),
    // headPic() {
    //   return decodeURIComponent(this.$absUrl(this.user.imgUrl));
    // },
  },
};
